import { render, staticRenderFns } from "./showOnlyEn.vue?vue&type=template&id=66c5257a"
var script = {}
import style0 from "./showOnlyEn.vue?vue&type=style&index=0&id=66c5257a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports